import { render, staticRenderFns } from "./xxy-sales-ranking-board.vue?vue&type=template&id=4722005c&scoped=true"
import script from "./xxy-sales-ranking-board.vue?vue&type=script&lang=js"
export * from "./xxy-sales-ranking-board.vue?vue&type=script&lang=js"
import style0 from "./xxy-sales-ranking-board.vue?vue&type=style&index=0&id=4722005c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4722005c",
  null
  
)

export default component.exports